<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <div class="w100">
      <div class="row mb-3">
        <div class="col-6">
          <label for="Label" class="form-label">名前</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder=""
            v-model="manage_role.label"
          />
        </div>
      </div>
      <h5 class="mb-2">権限付与ページ</h5>
      <div class="mb-2">
        <p class="alert alert-warning">
          パスは/member/*とすると/member/以下のページを一括で指定します。
        </p>
      </div>
      <div class="mb-3">
        <div
          class="row mb-2"
          v-for="(target_data, index) in manage_role.target_data"
          :key="index"
        >
          <div class="col-6">
            <bs-select
              :options="role_page_path_list"
              :nullOption="false"
              v-model="target_data.page_path"
            ></bs-select>
            <!-- <input
              type="text"
              class="form-control"
              :id="'page_path_data_' + target_data.id"
              placeholder=""
              v-model="target_data.page_path"
            /> -->
          </div>
          <div class="col-4">
            <bs-select
              :options="target_type_list_comp(target_data.page_path)"
              :nullOption="false"
              v-model="target_data.target_type"
            ></bs-select>
          </div>
          <div class="col-2">
            <button
              type="submit"
              @click="del_target(index)"
              class="btn btn-sm btn-warning"
            >
              削除
            </button>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="col text-end">
          <button
            type="submit"
            @click="add_target"
            class="btn btn-sm btn-light btn-outline-secondary"
          >
            追加
          </button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center">
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
// import '../../assets/bootstrap/css/sc.css';
import axios from 'axios'
import config from '../../../const'

export default {
  name: 'StaffDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'データ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      manage_role: {},
      target_type_list: [
        {
          key: 'visible',
          label: '閲覧・アクセス'
        },
        {
          key: 'editable',
          label: '編集'
        }
      ],
      target_data_def: {
        id: 0,
        stat: 0,
        manage_role_id: 0,
        target_type: 'visible',
        page_path: ''
      }
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsCheckBox,
  },
  methods: {
    // add_form
    async add_target() {
      const add_form = { ...this.target_data_def }
      const target_tmp = [...this.manage_role.target_data]
      target_tmp.push({ ...add_form })
      this.manage_role.target_data = target_tmp
    },
    // del_form
    async del_target(index) {
      const target_tmp = [...this.manage_role.target_data]
      if (target_tmp[index] && target_tmp[index].id > 0) {
        target_tmp[index].stat = 9
        this.manage_role.target_data = target_tmp
        await this.update()
      } else {
        target_tmp.splice(index, 1)
        this.manage_role.target_data = target_tmp
      }
    },

    async loadManageRole() {
      const params = {}
      params['id'] = this.targetid
      await axios
        .post(
          config.BASE_API_URL + '/manage_role/lists',
          this.setParams_S(params),
          this.cHeader
        )
        .then(async response => {
          console.log('loadManage', response)
          this.manage_role =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.manage_role = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },

    update() {
      return this.$store
        .dispatch('updateBasic', {
          data: this.manage_role,
          target: 'manage_role'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadManage()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({
      // manage_account_level: state => state.apidata.manage_account_level
    }),
    target_type_list_comp: function () {
      const list = this.target_type_list
      return function (page_path) {
        console.log('target_type_list_comp', page_path)
        if (page_path.indexOf('/download/') >= 0) {
          return [
            {
              key: 'editable',
              label: 'ダウンロード許可'
            }
          ]
        }
        return list
      }
    },
    manage_role_list: function () {
      return this.manage_role_obj ? this.manage_role_obj : []
    },
    disabledChk: function () {
      if (
        this.manage_account.pass_chg_flg == 'false' ||
        this.manage_account.pass_chg_flg == false
      ) {
        return true
      } else {
        return false
      }
    },
    dataClassChk: function () {
      const manage_account = this.manage_account
      return function (clinic_id) {
        if (
          typeof manage_account === 'object' &&
          typeof manage_account.relations === 'object' &&
          manage_account.relations.find(rel => {
            return rel.clinic_id == clinic_id
          })
        ) {
          return true
        }
        return false
      }
    },
    dataClass: function () {
      const dataClassChk = this.dataClassChk
      return function (clinic_id) {
        if (dataClassChk(clinic_id)) {
          return 'btn-primary'
        }
        return 'btn-light btn-outline-secondary'
      }
    },
    role_page_path_list: function () {
      const tmps = [
        { key: '/application/*', label: '会員申請一覧と詳細' },
        { key: '/application/list', label: '会員申請一覧' },
        { key: '/application/data', label: '会員申請詳細' },
        { key: '/club_application/*', label: 'クラブ申請一覧と詳細' },
        { key: '/club_application/list', label: 'クラブ申請一覧' },
        { key: '/club_application/data', label: 'クラブ申請詳細' },
        { key: '/download/*', label: 'ダウンロード' },
        { key: '/download/member', label: '会員DL' },
        { key: '/download/club', label: 'クラブDL' },
        { key: '/download/owner', label: '主催者DL' },
        { key: '/download/sales', label: '販売データDL' },
        { key: '/member/*', label: '会員一覧と詳細' },
        { key: '/member/list', label: '会員一覧' },
        { key: '/member/data', label: '会員詳細' },
        { key: '/club/*', label: 'クラブ一覧と詳細' },
        { key: '/club/list', label: 'クラブ一覧' },
        { key: '/club/data', label: 'クラブ詳細' },
        { key: '/information/*', label: 'お知らせ一覧と詳細' },
        { key: '/information/list', label: 'お知らせ一覧' },
        { key: '/information/data', label: 'お知らせ詳細' },
        { key: '/owener/*', label: '主催者一覧と詳細' },
        { key: '/owner/list', label: '主催者一覧' },
        { key: '/owner/data', label: '主催者詳細' },
        { key: '/system_entry/*', label: 'エントリーシステム' },
        { key: '/sales/*', label: '販売一覧と詳細' },
        { key: '/sales/list', label: '販売一覧' },
        { key: '/sales/csv_export', label: '販売CSV出力' },
        { key: '/payment_setting/list', label: '決済設定' },
        { key: '/insurance/list', label: '保険データ' },
        { key: '/article/*', label: '商品一覧と詳細' },
        { key: '/article/list', label: '商品一覧' },
        { key: '/article/data', label: '商品詳細' },
        { key: '/article_category/*', label: '商品カテゴリ一覧と詳細' },
        { key: '/article_category/list', label: '商品カテゴリ一覧' },
        { key: '/article_category/data', label: '商品カテゴリ詳細' },
        { key: '/master/*', label: 'マスタ設定一覧と詳細' },
        { key: '/master/list', label: 'マスタ設定一覧' },
        { key: '/master/data', label: 'マスタ設定詳細' },
        { key: '/manage/*', label: '管理者一覧と詳細' },
        { key: '/manage/list', label: '管理者一覧' },
        { key: '/manage/data', label: '管理者詳細' },
        { key: '/manage_role/*', label: '管理者権限一覧と詳細' },
        { key: '/manage_role/list', label: '管理者権限一覧' },
        { key: '/manage_role/data', label: '管理者権限詳細' }
      ]
      return tmps
    }
  },

  async created() {
    // await this.loadClinicList()
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadManageRole()
      this.btnLabel = '更新'
    } else {
      this.manage_role = {
        id: 0,
        label: '',
        target_data: []
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
    // const ret = !Number.isNaN(this.targetid)
    //   ? {...this.$store.getters.getDepartmentById(this.targetid)}
    //   : {};
    // this.department = ret;
  },
  mounted: function () {
    this.fromParentTitle = '管理権限データ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
